import { useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/customTable.scss";
import useColumnResize from "../../hooks/useColumnResize";

const MapsTable = ({ data, onSortChange, onSelectionChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "Id", direction: "asc" });
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const navigate = useNavigate();
  const { getResizeProps } = useColumnResize();

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const handleRowClick = (item) => {
    navigate(`/information/${item.id}`);
  };

  const items = Array.isArray(data) ? data : [];
  const shouldEnableScroll = items.length > 20;

  return (
    <div
      style={
        shouldEnableScroll
          ? { maxHeight: "650px", overflowY: "auto" }
          : undefined
      }
    >
      <Table
        responsive
        striped
        bordered
        hover
        size="sm"
        className="custom-table"
      >
        <thead>
          <tr>
            <th onClick={() => requestSort("postcode")} {...getResizeProps()}>
              Kod {getSortArrow("postcode")}
            </th>
            <th onClick={() => requestSort("cityName")} {...getResizeProps()}>
              Miejscowość {getSortArrow("cityName")}
            </th>
            <th onClick={() => requestSort("streetName")} {...getResizeProps()}>
              Ulica {getSortArrow("streetName")}
            </th>
            <th onClick={() => requestSort("number")} {...getResizeProps()}>
              Nr domu {getSortArrow("number")}
            </th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr
                key={`${item.id}-${index}`}
                onClick={() => handleRowClick(item)}
                style={{
                  cursor: "pointer",
                  transition: "background-color 0.2s ease",
                }}
                onMouseEnter={(e) =>
                  (e.target.closest("tr").style.backgroundColor = "#f8f9fa")
                }
                onMouseLeave={(e) =>
                  (e.target.closest("tr").style.backgroundColor = "")
                }
              >
                <td>{item.postcode}</td>
                <td>{item.cityName}</td>
                <td>{item.streetName}</td>
                <td>{item.number}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="13" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default MapsTable;
